import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
const DURATION_SECONDS = 2 * 60 * 60; // 2 hours
const STORAGE_KEY = 'countdown_end_ts';
function getEndTime(): number {
  const stored = sessionStorage.getItem(STORAGE_KEY);
  if (stored) {
    const ts = parseInt(stored, 10);
    if (ts > Date.now()) return ts;
  }
  const end = Date.now() + DURATION_SECONDS * 1000;
  sessionStorage.setItem(STORAGE_KEY, String(end));
  return end;
}
function formatTime(seconds: number) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor(seconds % 3600 / 60);
  const s = seconds % 60;
  return {
    h: String(h).padStart(2, '0'),
    m: String(m).padStart(2, '0'),
    s: String(s).padStart(2, '0')
  };
}
export function CountdownBanner() {
  const [secondsLeft, setSecondsLeft] = useState<number>(() => {
    const end = getEndTime();
    return Math.max(0, Math.floor((end - Date.now()) / 1000));
  });
  useEffect(() => {
    const endTime = getEndTime();
    const tick = () => {
      const remaining = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
      setSecondsLeft(remaining);
    };
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, []);
  const {
    h,
    m,
    s
  } = formatTime(secondsLeft);
  const expired = secondsLeft === 0;
  return <motion.div className="fixed top-0 left-0 right-0 z-40 flex items-center justify-center gap-2 px-4 py-2.5" style={{
    backgroundColor: '#D4A017',
    borderBottom: '1px solid rgba(0, 0, 0, 0.15)'
  }} initial={{
    y: -40,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.5,
    ease: 'easeOut'
  }} data-id="element-35">
      {!expired ? <div className="flex items-center gap-2 flex-wrap justify-center" data-id="element-36">
          <span className="font-body text-xs sm:text-sm font-semibold uppercase tracking-wide" style={{
        color: '#1A1A1A'
      }} data-id="element-37">
            ⏰ PRECIO DE LANZAMIENTO — Oferta termina en:
          </span>
          <div className="flex items-center gap-1" data-id="element-38">
            {/* Hours */}
            <motion.div key={`h-${h}`} initial={{
          opacity: 0.5,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.15
        }} className="flex items-center justify-center rounded font-serif-display font-bold text-sm sm:text-base tabular-nums min-w-[2rem] px-1.5 py-0.5" style={{
          backgroundColor: 'rgba(0,0,0,0.15)',
          color: '#1A1A1A',
          border: '1px solid rgba(0,0,0,0.2)'
        }} data-id="element-39">
              {h}
            </motion.div>
            <span className="font-bold text-sm" style={{
          color: '#1A1A1A'
        }} data-id="element-40">
              :
            </span>
            {/* Minutes */}
            <motion.div key={`m-${m}`} initial={{
          opacity: 0.5,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.15
        }} className="flex items-center justify-center rounded font-serif-display font-bold text-sm sm:text-base tabular-nums min-w-[2rem] px-1.5 py-0.5" style={{
          backgroundColor: 'rgba(0,0,0,0.15)',
          color: '#1A1A1A',
          border: '1px solid rgba(0,0,0,0.2)'
        }} data-id="element-41">
              {m}
            </motion.div>
            <span className="font-bold text-sm" style={{
          color: '#1A1A1A'
        }} data-id="element-42">
              :
            </span>
            {/* Seconds */}
            <motion.div key={`s-${s}`} initial={{
          opacity: 0.5,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.15
        }} className="flex items-center justify-center rounded font-serif-display font-bold text-sm sm:text-base tabular-nums min-w-[2rem] px-1.5 py-0.5" style={{
          backgroundColor: 'rgba(0,0,0,0.15)',
          color: '#1A1A1A',
          border: '1px solid rgba(0,0,0,0.2)'
        }} data-id="element-43">
              {s}
            </motion.div>
          </div>
        </div> : <motion.span initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} className="font-body text-sm font-bold uppercase tracking-wide" style={{
      color: '#C0392B'
    }} data-id="element-44">
          ⚠️ ¡Oferta expirada! El precio puede subir en cualquier momento.
        </motion.span>}
    </motion.div>;
}